<template>
  <div>
    <h1>in Equity Company</h1> {{ secId }}
  </div>
</template>

<script>
import { useRoute } from 'vue-router';

export default {
  setup() {
    const route = useRoute();
    const secId = route.query.shareClassId;
    return {
      secId
    }
  }
}
</script>

<style></style>